export const AUTH_ROUTES = {
  signIn: '/auth/sign-in',
  signUp: '/auth/sign-up',
  verification: '/auth/sign-up/verification',
  forgotPassword: '/auth/forgot-password',
  checkEmail: '/auth/check-email',
  newPassword: '/auth/new-password',
  socialCallback: '/auth/social-callback',
};